import { Box } from "@mui/material";
import {  BsArrowLeftShort } from "react-icons/bs";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import AdmissionForm from "./AdmissionForm";
import { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import FormLoader from "../../../FormLoader";
import { GoBackDiv } from "../../../../pages/student_mgt/stu_mgt.style";
import AdDrawer from "../../../SingleParent/AdDrawer";
import { AdmissionReport, AdmissionSlip } from "../../../SingleParent";
import AdSideBar from "../../../SingleParent/AdSideBar";
import api from "../../../../services/QualityAssurance";

const SingleAdmission = () => {
    const { admToken, user } = useSelector((state) => state.auth);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});
    const location = useLocation();
    const { phoneNumber } = useParams();
    const navigate = useNavigate();
    const tab_id = Number(new URLSearchParams(location.search).get("tab")) || 1;
    const studentPhoneNumber = phoneNumber || "08035026137";

    const fetchData = useCallback(async () => {
        try {
            setLoading(true);
            const res = await api.getStudentDetails(admToken, user.schoolId, "08035026137");
            if (res.status && res.statusCode === 2) {
            setData(res.data);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    }, [admToken, user.schoolId, phoneNumber]);
  
    useEffect(() => {
        fetchData();
    }, [fetchData]);

  return (
    <>
      <Box>
        <Box mt={2} sx={{ display: "flex", justifyContent: "space-between" }}>
          <GoBackDiv style={{ cursor: "pointer" }}>
            <div onClick={() => navigate(-1)}>
              <BsArrowLeftShort />
            </div>
            <span>Back To List</span>
          </GoBackDiv>
        </Box>
        <Box sx={{ display: { lg: "none", sm: "block" } }}>
          <AdDrawer />
        </Box>

        <Box
          sx={{
            minHeight: "68vh",
            overflow: "scroll",
            display: "flex",
            justifyContent: "space-between",
            mt: 3,
          }}
        >
          <Box
            sx={{
              width: "25%",
              display: { lg: "block", md: "none", sm: "none", xs: "none" },
              height: "68vh",
            }}
          >
            <AdSideBar />
          </Box>
          <Box
            sx={{
              width: { lg: "72%", sm: "100%", xs: "100%" },
              p: 2,
            }}
          >
            {loading ? <FormLoader /> : (
              <>
                {tab_id === 1 && <AdmissionForm data={data}/>}
                {tab_id === 2 && <AdmissionSlip />}
                {tab_id === 3 && <AdmissionReport />}
              </>
            )}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default SingleAdmission;
